import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TDezitakoFileDetailRes,
  TDezitakoKintaiConfirmListGetReq,
  TDezitakoKintaiConfirmListGetRes,
} from "./TDegitako"

/**
 * デジタコに対するAPIリクエスト用サービス
 *
 * @export
 * @class DezitakoService
 * @extends {ConnectApi}
 */
export default class DezitakoService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TDezitakoKintaiConfirmListGetReq} params
   * @memberof DezitakoService
   */
  getList = async (params: TDezitakoKintaiConfirmListGetReq) => {
    try {
      const res: AxiosResponse<
        TApiResponse<TDezitakoKintaiConfirmListGetRes[]>
      > = await this.getInner(`/truckcontrol/digitachokintai`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 取込ファイル明細ビューア（内部調査用）取得
   * 1ファイルから生まれた生データ(配送明細)と集計デジタコ勤怠を取得する
   *
   * @param {number} torikomiFileId 取込ファイルID
   * @memberof DezitakoService
   */
  getFileDetail = async (torikomiFileId: number) => {
    try {
      const res: AxiosResponse<TApiResponse<TDezitakoFileDetailRes>> =
        await this.getInner(`/truckcontrol/digitachokintai/filedetail`, {
          torikomiFileId,
        })
      return res.data
    } catch (err) {
      throw err
    }
  }
}
